import 'regenerator-runtime';

// import * as Sentry from '@sentry/browser';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

// if (import.meta.env.MODE === 'production') {
//   Sentry.init({dsn: 'https://723c0c1ab9aa4d1f9e6be2dfbe2f474a@sentry.x5.ru/368'});
// }

ReactDOM.render(<App />, document.querySelector('#root'));

// If you want your app to work offline and load faster, you can change
// somwchange unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
